import { Component } from '@angular/core';
import { Router} from '@angular/router';
import { SessionService } from './session.service'
import {Md5} from 'ts-md5/dist/md5';
import { httpservice } from 'http/http';

@Component({
  moduleId: module.id,
  selector: 'app',
  template: `<router-outlet></router-outlet>`,
  providers: [SessionService,Md5,httpservice]
})
export class AppComponent {
  currentUser;
  currentPassword;
  constructor(private _sessionService:SessionService,private router: Router) {

    if(this._sessionService.getSessionLogin()){

      if(this._sessionService.getSessionPermission()=="1"){
        this.router.navigate(['/default-layout/home']);
      }else if(this._sessionService.getSessionPermission()=="2"){
        this.router.navigate(['//default-layout/home']);
      }else if(this._sessionService.getSessionPermission()=="3"){
        this.router.navigate(['/default-layout/report-daily']);
      }else if(this._sessionService.getSessionPermission()=="4"){
        this.router.navigate(['/default-layout/report-rm-stock']);
      }else if(this._sessionService.getSessionPermission()=="5"){
        this.router.navigate(['/default-layout/information-part-delay-delivery-plating']);
      }else if(this._sessionService.getSessionPermission()=="6"){
        this.router.navigate(['/default-layout/daily-scrap-record']);
      }
      else{
        this.router.navigate(['/extra-layout/sign-in']);
      }

      //this.router.navigate(['/default-layout/dashboard']);
      
    }else{
      this.router.navigateByUrl('extra-layout/sign-in');
    }



  }



}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/app.component.ts